function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProFeaturesGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 67.53,
    y: 27.66,
    width: 212.7,
    height: 266.68,
    style: {
      fill: "#ebf2f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,169.91l22.89-11s8.61-14.39-4.3-16.52-16.36,11-16.36,11Z",
    style: {
      fill: "#695ebf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.1,
    y: 130.8,
    width: 185.56,
    height: 137.55,
    rx: 1.36,
    transform: "translate(419.45 -20.3) rotate(90)",
    style: {
      fill: "#695ebf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.52,
    y: 139.22,
    width: 170.32,
    height: 122.31,
    transform: "translate(421.05 -20.3) rotate(90)",
    style: {
      fill: "#383266"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.52,
    y: 139.22,
    width: 168.72,
    height: 120.71,
    transform: "translate(419.45 -20.3) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.43,109.71H188.32l1-2.91.59-1.67,2-5.75A3.59,3.59,0,0,1,195.35,97H244.4a3.58,3.58,0,0,1,3.38,2.39l2,5.75.59,1.67Z",
    style: {
      fill: "#695ebf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.3,
    y: 132.22,
    width: 74.13,
    height: 13.66,
    style: {
      fill: "#e4e0ff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.3,
    y: 160.45,
    width: 74.13,
    height: 13.66,
    style: {
      fill: "#e4e0ff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.3,
    y: 188.68,
    width: 74.13,
    height: 13.66,
    style: {
      fill: "#e4e0ff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.3,
    y: 216.92,
    width: 74.13,
    height: 13.66,
    style: {
      fill: "#e4e0ff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.3,
    y: 245.15,
    width: 74.13,
    height: 13.66,
    style: {
      fill: "#e4e0ff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.59,
    y: 132.22,
    width: 14.25,
    height: 13.66,
    style: {
      fill: "#e4e0ff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.59,
    y: 160.45,
    width: 14.25,
    height: 13.66,
    style: {
      fill: "#e4e0ff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.59,
    y: 188.68,
    width: 14.25,
    height: 13.66,
    style: {
      fill: "#e4e0ff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.59,
    y: 216.92,
    width: 14.25,
    height: 13.66,
    style: {
      fill: "#e4e0ff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.59,
    y: 245.15,
    width: 14.25,
    height: 13.66,
    style: {
      fill: "#e4e0ff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.88,
    cy: 101.51,
    r: 2.15,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.4 106.8 189.35 106.8 189.94 105.13 249.81 105.13 250.4 106.8",
    style: {
      fill: "#383266"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.53 136.57 262.95 134.99 257.97 139.97 254.47 136.47 252.89 138.05 257.94 143.1 257.97 143.06 258 143.1 264.53 136.57",
    style: {
      fill: "#bf5eb7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.53 165.24 262.95 163.66 257.97 168.64 254.47 165.14 252.89 166.72 257.94 171.77 257.97 171.74 258 171.77 264.53 165.24",
    style: {
      fill: "#bf5eb7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.53 193.23 262.95 191.65 257.97 196.63 254.47 193.13 252.89 194.72 257.94 199.76 257.97 199.73 258 199.76 264.53 193.23",
    style: {
      fill: "#bf5eb7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.53 220.54 262.95 218.96 257.97 223.94 254.47 220.44 252.89 222.03 257.94 227.07 257.97 227.04 258 227.07 264.53 220.54",
    style: {
      fill: "#bf5eb7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.95,
    y: 75.72,
    width: 30.85,
    height: 114.81,
    transform: "translate(279.41 68.88) rotate(109.53)",
    style: {
      fill: "#bf5eb7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.69,
    y: 75.72,
    width: 13.37,
    height: 114.81,
    transform: "matrix(-0.33, 0.94, -0.94, -0.33, 279.41, 68.88)",
    style: {
      fill: "#e370d9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.33 166.85 174.64 137.78 192.25 152.21 199.68 158.3 209.86 166.63 196.71 166.7 187.09 166.74 164.33 166.85",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.71 166.7 199.68 158.3 209.86 166.63 196.71 166.7",
    style: {
      fill: "#bf5eb7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.42,130.36l-10.71-3.8a8.39,8.39,0,0,1-5.1-10.72l5.23-14.75a2.62,2.62,0,0,1,.15-.39A6.81,6.81,0,0,1,59.53,97l12.2,4.33L64.35,122.1Z",
    style: {
      fill: "#e4e0ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.35,122.1l-10.7-3.79a8.4,8.4,0,0,1-5.11-10.72L51,100.7A6.81,6.81,0,0,1,59.53,97l12.2,4.33Z",
    style: {
      fill: "#efedff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.16 105.38 75.61 126.15 72.62 134.37 61.3 130.36 64.22 122.1 71.61 101.28 83.16 105.38",
    style: {
      fill: "#695ebf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.61 126.15 72.62 134.37 61.3 130.35 64.22 122.1 75.61 126.15",
    style: {
      fill: "#6157b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.69,216.87a28.22,28.22,0,0,0-.41,4.28,24.12,24.12,0,0,0,1.6,4.44,18.75,18.75,0,0,0,3.91.86,14.75,14.75,0,0,0,1.5-2.4s.95,0,1.16-.31a20.35,20.35,0,0,0-.24-5.78C84.85,217.18,77.69,216.87,77.69,216.87Z",
    style: {
      fill: "#ffcfb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.84,140.06s-.69.29-1,0-1.21-4.49-.93-4.83a1.16,1.16,0,0,1,1.58-.14C102,135.57,101.84,140.06,101.84,140.06Z",
    style: {
      fill: "#ffd8bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.06,296.64a27.77,27.77,0,0,1-.2,5.09c-.36,1.23-3.19,1.4-4,1.75a20.63,20.63,0,0,1-6.7,1.68c-1.18.14-1.34-.71.08-1.43a13.23,13.23,0,0,0,6.21-6.46Z",
    style: {
      fill: "#321707"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.38,297.94c-1-.09-1.26.88-4.41-.23a.49.49,0,0,1-.16,0s-8.57-50.31-14.28-73.94c-2.23,26.6-5.4,73.94-5.4,73.94a.49.49,0,0,1-.16,0c-3.15,1.11-3.37.14-4.41.23-.5,0-6.29-53.05-3.58-88.46l26.74-1.27C129,243.6,130.92,298,130.38,297.94Z",
    style: {
      fill: "#4a4387"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.88,296.64a27.77,27.77,0,0,0,.2,5.09c.36,1.23,3.19,1.4,4,1.75a20.63,20.63,0,0,0,6.7,1.68c1.18.14,1.34-.71-.08-1.43a13.23,13.23,0,0,1-6.21-6.46Z",
    style: {
      fill: "#321707"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.59,207.74c0,1-.88,1.55-1.84,1.84-3.44,1-13.57,1.91-20.83,2-4.46.08-7.84-.12-7.9-.75-.4-4.1-.87-8.33-1.38-12.55-2.51-20.66-5.87-40.93-4.18-42.18,2.16-1.59,13.56-7.33,13.56-7.33l8.33-.06,13.83,4.91S128.07,198.42,127.59,207.74Z",
    style: {
      fill: "#695ebf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.84,151.18a6,6,0,0,1-2.41-1.91v-7.64l8.85-1.85h0l1.11,9.34h0C112.48,151.81,107.75,152,105.84,151.18Z",
    style: {
      fill: "#ffc09c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.36,127.41s.08,4.1.3,5.71a44.33,44.33,0,0,1-.55,7.69c-.19,1-1.8,6-2.75,6.38a24.83,24.83,0,0,1-6.56.27c-.73-.22-2.15-.37-4.28-6.72-.67-2-1-12.82-.37-13.33S113.53,122.65,115.36,127.41Z",
    style: {
      fill: "#ffd8bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.57,140.06s.69.29,1,0,1.61-4.33,1.11-5a1.38,1.38,0,0,0-1.76,0C114.38,135.57,114.57,140.06,114.57,140.06Z",
    style: {
      fill: "#ffd8bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.79,129.92s9.26.09,11.75-2.12-.51-2.73-5-4.13c-4.14-1.29-8.21,1.52-8.75,2.74S102.79,129.92,102.79,129.92Z",
    style: {
      fill: "#4a3d6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.07,134.83l-.62,3.35s-.75-.22-.55-1.81a9.34,9.34,0,0,0-.34-5.31,40.79,40.79,0,0,1-1.36-4.12s1.38-1.34,2.51-1,1.47,2.29,1.13,4.2S116.07,134.83,116.07,134.83Z",
    style: {
      fill: "#4a3d6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.15,127.41s-.93,0-.85,1.71.72,7.47.85,7.86a7.45,7.45,0,0,1,.21,1.2.87.87,0,0,0,.68-.7c.17-.63-.55-4.56.43-6.74s1.87-3.15.68-3.66A1.82,1.82,0,0,0,101.15,127.41Z",
    style: {
      fill: "#4a3d6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,155.87s-8.24,4-11,24c-1.35,9.74-5.06,27-3.93,35.68.23,1.79,2.74,2.41,4.52,2.73s3.63.72,3.92-.9c2.55-14.57,8.63-51.25,18.35-59.81C107.42,154.4,92,155.87,92,155.87Z",
    style: {
      fill: "#695ebf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.62,128.44s-2.69,2.21-2.61,3.23,4.17,2,4.17,2,7.16-.1,8.75-1.49a2.7,2.7,0,0,0-1.78-3.35c-2.55-1-6.38-1.66-7.12-1.45A5.28,5.28,0,0,0,147.62,128.44Z",
    style: {
      fill: "#ffcfb5"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProFeaturesGraphic);
export default __webpack_public_path__ + "static/media/pro_features_graphic.ddebb65db16f68405c8002d19d53df99.svg";
export { ForwardRef as ReactComponent };